module.exports = __webpack_public_path__ + "static/SM-logo-white-c98454071cb55c743a9fae60f1f9ab1c.png";